// extracted by mini-css-extract-plugin
module.exports = {"invalid-message":"_218orM5I6jGqCqdYLQsGYP"};